module.exports = __webpack_public_path__ + "img/hong3.d2bd274d.png";